<template>
    <div class="ord-wrap">
        <a-card :bordered="false" class="ord-title-card">
            <div class="ord-hd">
                <div>
                    <h2>Pedidos</h2>
                    <div class="ord-sub">Pedidos gerados a partir desta cotação</div>
                </div>
                <div class="ord-actions">
                    <a-button @click="handleTotalizadores">
                        <i class="fa-solid fa-calculator"></i>
                        {{ showTotalizadores ? "Ocultar Totalizadores" : "Mostrar Totalizadores" }}
                    </a-button>
                </div>
            </div>

            <a-form layout="vertical" class="ord-filterbar" @submit.prevent="applyFilters">
            <a-row :gutter="8">
                <a-col :xs="24" :s="12" :md="6" :lg="4" :xl="3">
                    <a-form-item>
                        <a-input
                            v-model="orderSearch"
                            placeholder="Número/ID do Pedido"
                            @pressEnter="applyFilters"
                        />
                    </a-form-item>
                </a-col>

                <a-col :xs="24" :s="12" :md="6" :lg="4" :xl="3">
                    <a-form-item>
                        <a-select
                            v-model="statusFilter"
                            :options="statusOptions"
                            placeholder="Selecione o status"
                            allowClear
                            optionFilterProp="label"
                            :filterOption="filterOption"
                            mode="multiple"
                            class="fixed-height-select"
                        />
                    </a-form-item>
                </a-col>

                <a-col :xs="24" :s="12" :md="10" :lg="6" :xl="3">
                    <a-form-item>
                        <a-select
                            v-model="storeFilter"
                            show-search
                            :options="storeOptions"
                            :loading="loadingFilterOptions"
                            placeholder="Selecione a empresa"
                            allowClear
                            optionFilterProp="label"
                            :filterOption="filterOption"
                            mode="multiple"
                            class="fixed-height-select"
                        />
                    </a-form-item>
                </a-col>

                <a-col :xs="24" :s="12" :md="10" :lg="6" :xl="3">
                    <a-form-item>
                        <a-select
                            v-model="providerFilter"
                            show-search
                            :options="providerOptions"
                            :loading="loadingFilterOptions"
                            placeholder="Selecione o fornecedor"
                            allowClear
                            optionFilterProp="label"
                            :filterOption="filterOption"
                            mode="multiple"
                            class="fixed-height-select"
                        />
                    </a-form-item>
                </a-col>

                <a-col :xs="24" :s="12" :md="10" :lg="6" :xl="3">
                    <a-form-item>
                        <a-select
                            v-model="sellerFilter"
                            show-search
                            :options="sellerOptions"
                            :loading="loadingFilterOptions"
                            placeholder="Selecione o vendedor"
                            allowClear
                            optionFilterProp="label"
                            :filterOption="filterOption"
                            mode="multiple"
                            class="fixed-height-select"
                        />
                    </a-form-item>
                </a-col>

                <a-col flex="auto" class="ord-filter-actions-col">
                    <a-form-item>
                        <div class="ord-filter-actions">
                            <a-button type="danger" @click="clearFilters">
                                <i class="fa-solid fa-filter-circle-xmark"></i> Limpar Filtros
                            </a-button>
                            <a-button type="primary" icon="search" @click="applyFilters">
                                Filtrar
                            </a-button>
                        </div>
                    </a-form-item>
                </a-col>
            </a-row>
            </a-form>
        </a-card>

        <div class="ord-stats">
            <dashboard-stats
                :items="dashboardCards"
                :show-totalizadores="showTotalizadores"
                dynamic-width
                @click="aplicarFiltroRapido"
            />
        </div>

        <a-card :bordered="false" class="ord-card" :style="selectedRowKeys.length && { marginBottom: '60px' }">
            <OrdersTable
                :data-source="rows"
                :loading="is_loading || exportingPdf"
                :printing="exportingPdf"
                :resyncing="resyncing"
                :notifying="notifying"
                :pagination="pagination"
                :row-selection="rowSelectionComputed"
                :can-cancel-order="canCancelOrder"
                :can-send-notification="canSendNotification"
                @change="handleTableChange"
                @print-selected="printSelected"
                @cancel-selected="bulkCancelOrders"
                @resync-selected="bulkResyncOrders"
                @notify-selected="bulkNotifyOrders"
                @clear-selection="clearSelection"
            >
                <template slot="actions" slot-scope="{ record }">
                    <ActionMenu :actions="getActions(record)" />
                </template>
            </OrdersTable>
        </a-card>

        <a-modal
            v-model="ratingVisible"
            :footer="null"
            :mask-closable="false"
            :width="600"
            centered
        >
            <div class="text-center">
                <h4>
                    Como foi sua experiência com
                    <span>{{ indexArray }}</span>?
                </h4>

                <div class="ord-rating">
                    <star-rating
                        v-model="rating"
                        @rating-selected="modalClick"
                        :star-size="50"
                        :show-rating="false"
                    />
                </div>

                <h2 class="mt-3">{{ notaVendedor }}</h2>

                <h5 class="mt-4">Escolha um ou mais problemas que você encontrou:</h5>

                <a-checkbox-group v-model="checkbox">
                    <div class="ord-rating-options">
                        <a-checkbox
                            v-for="item in arrayCheckbox"
                            :key="item.id"
                            :value="item.id"
                        >
                            {{ item.descricao }}
                        </a-checkbox>
                    </div>
                </a-checkbox-group>

                <div class="mt-4">Sua avaliação é feita de forma anônima.</div>

                <a-button class="mt-3" type="primary" @click="postAvaliacaoPedido">
                    Enviar Feedback
                </a-button>
            </div>
        </a-modal>

    </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import V3OrderService from "@/services/v3/order.service";
import SellersService from "@/services/v2/sellers.service";
import RequestService from "@/services/v3/request.service";
import QuotationService from "@/services/OrderService";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import OrdersTable from "@/components/cliente/monitors/orders/OrdersTable.vue";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import StatsCards from "@/components/cliente/monitors/StatsCards.vue";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { perm_mixin } from "@/mixins/permission.mixin";

export default {
    name: "OrdersTableComponent",
    mixins: [loaderMixin, perm_mixin],
    components: { OrdersTable, ActionMenu, "dashboard-stats": StatsCards },
    data() {
        return {
            svc: new V3OrderService(),
            sellers_svc: new SellersService(),
            request_svc: new RequestService(),
            quotation_svc: new QuotationService(),
            rows: [],
            is_loading: false,
            exportingPdf: false,
            resyncing: false,
            notifying: false,
            showTotalizadores: true,
            summary: {},
            quickFilters: {},
            moment,
            orderSearch: null,
            statusFilter: [],
            storeFilter: [],
            providerFilter: [],
            sellerFilter: [],
            storeOptions: [],
            providerOptions: [],
            sellerOptions: [],
            loadingFilterOptions: false,
            statuses: [
                { value: "P", text: "Pendente" },
                { value: "C", text: "Confirmado" },
                { value: "D", text: "Entregue" },
                { value: "ND", text: "Não Entregue" },
            ],
            selectedRowKeys: [],
            selectedMap: {},
            ratingVisible: false,
            rating: 0,
            checkbox: [],
            arrayCheckbox: [],
            notaVendedor: null,
            indexArray: "",
            indexIdPedido: null,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: false,
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
        };
    },
    computed: {
        ...mapState(["user"]),
        statusOptions() {
            return this.statuses.map((status) => ({ value: status.value, label: status.text }));
        },
        canCancelOrder() {
            const user = this.user || {};
            return !user.perms?.some(
                (perm) =>
                    perm.resource === "REQUEST_ORDER" &&
                    perm.action === "CANCEL" &&
                    perm.subject_ids === null
            );
        },
        canSendNotification() {
            return this.can("ORDER", "SEND_NOTIFICATION");
        },
        selectedRows() {
            return Object.values(this.selectedMap);
        },
        rowSelectionComputed() {
            return {
                selectedRowKeys: this.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRowKeys = selectedRowKeys;
                    selectedRows.forEach((row) => this.$set(this.selectedMap, row.id, row));

                    const keptKeys = selectedRowKeys.map(String);
                    Object.keys(this.selectedMap).forEach((key) => {
                        if (!keptKeys.includes(key)) this.$delete(this.selectedMap, key);
                    });
                },
                onSelectAll: async (selected) => {
                    if (this.pagination.total <= this.pagination.pageSize) return;

                    if (selected) {
                        const result = await this.$swal({
                            title: "Selecionar pedidos",
                            text: "Deseja selecionar apenas a página atual ou todos os pedidos filtrados?",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Todos",
                            cancelButtonText: "Página atual",
                        });
                        if (result.isConfirmed) this.selectAllFiltered();
                        return;
                    }

                    const result = await this.$swal({
                        title: "Remover seleção",
                        text: "Deseja remover apenas a página atual ou todos os pedidos filtrados?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Todos",
                        cancelButtonText: "Página atual",
                    });
                    if (result.isConfirmed) this.deselectAllFiltered();
                },
            };
        },
        dashboardCards() {
            return [
                { key: "pedidos", title: "Pedidos", icon: "orders", value: this.summary.total_pedidos, borderColor: "#1890ff" },
                { key: "pendentes", title: "Pendentes", icon: "schedule", value: this.summary.pendentes, borderColor: "#faad14" },
                { key: "confirmados", title: "Em entrega", icon: "local_shipping", value: this.summary.em_entrega, borderColor: "#722ed1" },
                { key: "entregas_hoje", title: "Entregas hoje", icon: "delivery_truck_speed", value: this.summary.entregas_hoje, borderColor: "#13c2c2" },
                { key: "atrasados", title: "Atrasados", icon: "traffic_jam", value: this.summary.atrasados, valueColor: "#fa8c16", borderColor: "#fa8c16" },
                { key: "divergencia", title: "Divergência", icon: "check_circle_unread", value: this.summary.divergencia, valueColor: "#cf1322", borderColor: "#cf1322" },
                { key: "valor_total", title: "Valor Total (R$)", icon: "paid", value: this.summary.valor_total, precision: 2, borderColor: "#0958d9" },
                { key: "economia", title: "Economia (R$)", icon: "savings", value: this.summary.economia, precision: 2, valueColor: "#3f8600", borderColor: "#52c41a" },
            ];
        },
    },
    created() {
        this.load();
        this.loadRatingComments();
        this.loadFilterOptions();
    },
    methods: {
        buildParams(page = null) {
            return {
                page,
                page_size: page ? this.pagination.pageSize : null,
                "filter[numerocotacao]": this.$route.params.id,
                "filter[idPedido]": this.orderSearch || undefined,
                "filter[loja]": this.storeFilter.length ? this.storeFilter.join(",") : undefined,
                "filter[fornecedor]": this.providerFilter.length ? this.providerFilter.join(",") : undefined,
                "filter[vendedor]": this.sellerFilter.length ? this.sellerFilter.join(",") : undefined,
                "filter[status]": this.statusFilter.length ? this.statusFilter.join(",") : undefined,
                ...this.quickFilters,
            };
        },
        loadFilterOptions() {
            this.loadingFilterOptions = true;
            this.svc
                .query({ "filter[numerocotacao]": this.$route.params.id, page_size: 500 })
                .then((res) => res.data)
                .then((response) => {
                    const sellersById = {};
                    const storesById = {};
                    const providersById = {};

                    (response.data || []).forEach((order) => {
                        if (order.seller && order.seller.id) sellersById[order.seller.id] = order.seller.name;
                        if (order.store && order.store.id) storesById[order.store.id] = order.store.name;
                        if (order.provider && order.provider.id) providersById[order.provider.id] = order.provider.name;
                    });

                    this.sellerOptions = this.toOptions(sellersById);
                    this.storeOptions = this.toOptions(storesById);
                    this.providerOptions = this.toOptions(providersById);
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loadingFilterOptions = false;
                });
        },
        toOptions(map) {
            return Object.keys(map)
                .map((id) => ({ value: Number(id), label: map[id] }))
                .sort((a, b) => a.label.localeCompare(b.label));
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toUpperCase()
                    .indexOf(input.toUpperCase()) >= 0
            );
        },
        applyFilters() {
            this.load(1);
        },
        clearFilters() {
            this.orderSearch = null;
            this.statusFilter = [];
            this.storeFilter = [];
            this.providerFilter = [];
            this.sellerFilter = [];
            this.quickFilters = {};
            this.load(1);
        },
        load(page = 1) {
            this.is_loading = true;

            this.svc
                .query(this.buildParams(page))
                .then((res) => res.data)
                .then((response) => {
                    this.rows = response.data;
                    this.pagination.total = response.meta.total;
                    this.pagination.current = response.meta.current_page;
                    this.pagination.pageSize = response.meta.per_page;
                    this.is_loading = false;
                })
                .catch((error) => {
                    this.is_loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });

            if (this.showTotalizadores) this.getSummary();
        },
        getSummary() {
            this.svc
                .summary(this.buildParams())
                .then((res) => {
                    this.summary = res.data;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        handleTotalizadores() {
            if (!this.showTotalizadores) this.getSummary();
            this.showTotalizadores = !this.showTotalizadores;
        },
        aplicarFiltroRapido(key) {
            switch (key) {
                case "pendentes":
                    this.quickFilters = { "filter[status]": "P" };
                    break;
                case "confirmados":
                    this.quickFilters = { "filter[status]": "C", "filter[status_recebido]": 0 };
                    break;
                case "entregas_hoje":
                    this.quickFilters = {
                        "filter[entregaInit]": moment().format("YYYY-MM-DD"),
                        "filter[entregaFinal]": moment().format("YYYY-MM-DD"),
                    };
                    break;
                case "atrasados":
                    this.quickFilters = { "filter[atrasados]": 1 };
                    break;
                case "divergencia":
                    this.quickFilters = { "filter[divergencia]": 1 };
                    break;
                default:
                    this.quickFilters = {};
            }
            this.load(1);
        },
        handleTableChange(pagination) {
            this.load(pagination.current);
        },
        getActions(record) {
            return [
                {
                    label: "Visualizar pedido",
                    icon: "shopping_cart",
                    onClick: () => this.goToOrder(record),
                },
                {
                    label: "Confirmar Entrega",
                    icon: "inventory",
                    iconClass: "action-success",
                    visible: record.status === "C" && !record.status_recebido,
                    onClick: () => this.confirmDelivery(record),
                },
                {
                    label: "Confirmar Pedido",
                    icon: "done",
                    iconClass: "action-success",
                    visible: record.status === "P" && !record.status_recebido,
                    onClick: () => this.confirmDeliveryStatusP(record),
                },
                {
                    label: "Informar Divergência",
                    icon: "warning",
                    iconClass: "action-warning",
                    visible: !!record.status_recebido,
                    onClick: () => this.sendToDivergency(record),
                },
                {
                    label: "Avaliar Vendedor",
                    icon: "star",
                    iconClass: "action-yellow",
                    onClick: () => this.openRating(record),
                },
                {
                    label: "Reenviar notificação",
                    icon: "campaign",
                    iconClass: "action-warning",
                    visible: this.can("ORDER", "SEND_NOTIFICATION"),
                    onClick: () => this.resendNotification(record.id),
                },
                {
                    label: "Falar com vendedor",
                    icon: "fab fa-whatsapp",
                    iconClass: "action-success",
                    href: record.seller && record.seller.phone ? `https://api.whatsapp.com/send?phone=${record.seller.phone}` : null,
                    target: "_blank",
                    visible: !!(record.seller && record.seller.phone),
                },
                {
                    label: "Exportar PDF",
                    icon: "picture_as_pdf",
                    iconClass: "action-danger",
                    disabled: this.exportingPdf,
                    loading: this.exportingPdf,
                    onClick: () => this.print(record),
                },
                {
                    label: "Reenviar para o ERP",
                    icon: "sync",
                    iconClass: "action-primary",
                    visible: !!(record.integration && record.integration.status !== "INTEGRATED"),
                    onClick: () => this.resyncOrder(record.id),
                },
                {
                    label: "Cancelar Pedido",
                    icon: "cancel",
                    iconClass: "action-danger",
                    visible: this.canCancelOrder,
                    onClick: () => this.cancelOrder(record),
                },
            ];
        },
        goToOrder(record) {
            const route = this.$router.resolve({
                name: "lancamento-cliente-monitores-vencedores",
                params: {
                    id: this.$route.params.id,
                    sellerid: record.seller && record.seller.id,
                    sid: record.store && record.store.id,
                    providerid: record.provider && record.provider.id,
                    cnpj: record.provider && record.provider.cnpj,
                },
            });
            window.open(route.href);
        },
        resendNotification(order_id) {
            this.confirm_action({
                message: "Confirma envio de notificação?",
                subtitle: "O vendedor será novamente notificado sobre este pedido!",
                callback: () => {
                    this.svc
                        .notifyMany([order_id])
                        .then(({ data }) => {
                            if (!data.notified.length) {
                                this.present_error("Não foi possível reenviar a notificação deste pedido.");
                                return;
                            }
                            this.present_info("Notificação reenviada com sucesso!");
                        })
                        .catch((error) => {
                            ErrorHandlerService.handle(error, this.$store);
                        });
                },
            });
        },
        confirmDelivery(record) {
            this.confirm_action({
                message: "Confirma recebimento do pedido?",
                deny_text: "Com divergência!",
                cancel_buttom_color: "#4D4F5C",
                callback: () => {
                    this.sellers_svc.confirm_delivery(record.id).then(() => {
                        this.load(this.pagination.current);
                    });
                },
                deny_callback: () => {
                    this.sellers_svc.confirm_delivery(record.id);
                    this.sendToDivergency(record);
                },
            });
        },
        confirmDeliveryStatusP(record) {
            this.confirm_action({
                message: "Confirma recebimento do pedido?",
                cancel_buttom_color: "#4D4F5C",
                callback: () => {
                    this.sellers_svc.confirm_delivery_status_p(record.id).then(() => {
                        this.load(this.pagination.current);
                    });
                },
            });
        },
        sendToDivergency(record) {
            this.$router.push({
                name: "cliente-monitores-divergent",
                params: {
                    id: record.quotation_id,
                    sellerid: record.seller && record.seller.id,
                    sid: record.store && record.store.id,
                    providerid: record.provider && record.provider.id,
                },
            });
        },
        openRating(record) {
            this.indexArray = record.seller ? record.seller.name : "";
            this.indexIdPedido = record.id;
            this.rating = record.rating ? record.rating.score : 0;
            this.checkbox = record.rating && record.rating.comentarios ? record.rating.comentarios.map((c) => c.id) : [];
            this.ratingVisible = true;
        },
        loadRatingComments() {
            this.quotation_svc
                .list_rating_comments()
                .then((data) => {
                    this.arrayCheckbox = data.data.comentarios;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        modalClick() {
            const notas = {
                1: "Vendedor péssimo, poderia melhorar.",
                2: "Vendedor ruim, poderia melhorar.",
                3: "Vendedor regular, poderia melhorar.",
                4: "Vendedor bom, mas poderia melhorar.",
                5: "Vendedor Excelente!",
            };
            this.notaVendedor = notas[this.rating] || null;
        },
        postAvaliacaoPedido() {
            this.quotation_svc
                .rate({
                    id_pedido: this.indexIdPedido,
                    nota: this.rating,
                    comentarios: this.checkbox,
                    observacao: " ",
                })
                .then(() => {
                    this.ratingVisible = false;
                    this.rating = 0;
                    this.checkbox = [];
                    this.notaVendedor = null;
                    this.load(this.pagination.current);
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        cancelOrder(record) {
            if (!this.canCancelOrder) {
                this.$toast.error("Você não tem permissão para cancelar pedidos.");
                return;
            }

            this.$swal
                .fire({
                    title: "Tem certeza que deseja cancelar este pedido?",
                    icon: "warning",
                    input: "select",
                    inputOptions: {
                        1: "Quantidade Errada",
                        2: "Valores Divergentes",
                        3: "Ruptura de Produtos",
                        4: "Entrega não realizada",
                        5: "Outros",
                    },
                    inputPlaceholder: "Selecione um motivo",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Sim, cancelar",
                    cancelButtonText: "Não",
                    inputValidator: (value) => {
                        if (!value) return "Você precisa escolher um motivo!";
                    },
                })
                .then(({ value: motivoId, isConfirmed }) => {
                    if (!isConfirmed) return;

                    this.svc
                        .cancel(record.id, motivoId)
                        .then(() => {
                            this.$swal.fire("Sucesso!", "Pedido cancelado com sucesso!", "success");
                            this.load(this.pagination.current);
                            this.$emit("order-cancelled");
                        })
                        .catch((error) => {
                            ErrorHandlerService.handle(error, this.$store);
                        });
                });
        },
        resyncOrder(id) {
            this.$swal
                .fire({
                    title: "Deseja sincronizar novamente este pedido?",
                    text: "Esta operação irá enviar o pedido novamente para a retaguarda.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, sincronizar novamente.",
                })
                .then((resp) => {
                    if (!resp.isConfirmed) return;

                    this.present_loader("Ressincronizando...");
                    this.request_svc
                        .resyncOrder(id)
                        .then(() => {
                            this.dismiss_loader();
                            this.load(this.pagination.current);
                        })
                        .catch((error) => {
                            this.dismiss_loader();
                            ErrorHandlerService.handle(error, this.$store);
                        });
                });
        },
        print(record) {
            this.exportOrdersPdf([record.id]);
        },
        printSelected() {
            if (!this.selectedRows.length) {
                this.$swal.fire("Por favor,", "Selecione ao menos um pedido.");
                return;
            }

            const ids = this.selectedRows.map((r) => r.id);

            this.$swal
                .fire({
                    icon: "info",
                    title: "Deseja juntar as páginas?",
                    text: "Deseja que as informações sejam agrupadas no menor número de páginas possível?",
                    showDenyButton: true,
                    denyButtonText: "Não",
                    denyButtonColor: "red",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Sim",
                })
                .then((resp) => {
                    if (resp.isConfirmed || resp.isDenied) return this.exportOrdersPdf(ids, resp.isConfirmed);
                })
                .then((exported) => {
                    if (exported) this.clearSelection();
                });
        },
        exportOrdersPdf(ids, collapsePages = false) {
            this.exportingPdf = true;

            return this.svc
                .export_pdf(ids, collapsePages)
                .then((response) => response.data)
                .then((data) => {
                    const file = new Blob([data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL, "_blank");
                    setTimeout(() => URL.revokeObjectURL(fileURL), 60000);
                    return true;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                    return false;
                })
                .finally(() => {
                    this.exportingPdf = false;
                });
        },
        clearSelection() {
            this.selectedRowKeys = [];
            this.selectedMap = {};
        },
        async selectAllFiltered() {
            this.is_loading = true;
            try {
                const params = { ...this.buildParams(), export: "ids" };
                const { data } = await this.svc.query(params);
                const ids = Array.isArray(data.data) ? data.data : [];

                ids.forEach((id) => this.$set(this.selectedMap, id, { id }));
                this.selectedRowKeys = Object.values(this.selectedMap).map((row) => row.id);

                this.$swal.fire({
                    icon: "success",
                    title: "Seleção concluída",
                    text: `${ids.length} pedidos adicionados à seleção`,
                });
            } catch (error) {
                ErrorHandlerService.handle(error, this.$store);
            } finally {
                this.is_loading = false;
            }
        },
        async deselectAllFiltered() {
            this.is_loading = true;
            try {
                const params = { ...this.buildParams(), export: "ids" };
                const { data } = await this.svc.query(params);
                const ids = Array.isArray(data.data) ? data.data : [];

                ids.forEach((id) => this.$delete(this.selectedMap, id));
                this.selectedRowKeys = Object.values(this.selectedMap).map((row) => row.id);
            } catch (error) {
                ErrorHandlerService.handle(error, this.$store);
            } finally {
                this.is_loading = false;
            }
        },
        bulkCancelOrders() {
            if (!this.canCancelOrder) {
                this.$toast.error("Você não tem permissão para cancelar pedidos.");
                return;
            }

            this.$swal
                .fire({
                    title: `Cancelar ${this.selectedRows.length} pedido(s) selecionado(s)?`,
                    icon: "warning",
                    input: "select",
                    inputOptions: {
                        1: "Quantidade Errada",
                        2: "Valores Divergentes",
                        3: "Ruptura de Produtos",
                        4: "Entrega não realizada",
                        5: "Outros",
                    },
                    inputPlaceholder: "Selecione um motivo",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Sim, cancelar",
                    cancelButtonText: "Não",
                    inputValidator: (value) => {
                        if (!value) return "Você precisa escolher um motivo!";
                    },
                })
                .then(async ({ value: motivoId, isConfirmed }) => {
                    if (!isConfirmed) return;

                    const orderIds = this.selectedRows.map((record) => record.id);

                    this.is_loading = true;
                    try {
                        const { data: result } = await this.svc.cancelMany(orderIds, motivoId);
                        const failed = result.failed?.length || 0;

                        if (failed) {
                            this.$swal.fire(
                                "Atenção",
                                `${result.cancelled.length} de ${orderIds.length} pedidos cancelados. ${failed} falharam.`,
                                "warning"
                            );
                        } else {
                            this.$swal.fire("Sucesso!", "Pedidos cancelados com sucesso!", "success");
                        }
                    } catch (error) {
                        ErrorHandlerService.handle(error, this.$store);
                    } finally {
                        this.is_loading = false;
                    }

                    this.clearSelection();
                    this.load(this.pagination.current);
                    this.$emit("order-cancelled");
                });
        },
        bulkResyncOrders() {
            if (!this.selectedRows.length) return;

            this.$swal
                .fire({
                    title: `Reenviar ${this.selectedRows.length} pedido(s) para o ERP?`,
                    text: "Esta operação irá enviar os pedidos selecionados novamente para a retaguarda.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, reenviar",
                })
                .then(async (resp) => {
                    if (!resp.isConfirmed) return;

                    const orderIds = this.selectedRows.map((record) => record.id);

                    this.resyncing = true;
                    try {
                        await this.request_svc.resyncOrders(orderIds);
                        this.$swal.fire("Sucesso!", "Pedidos reenviados para o ERP com sucesso!", "success");
                        this.clearSelection();
                        this.load(this.pagination.current);
                    } catch (error) {
                        ErrorHandlerService.handle(error, this.$store);
                    } finally {
                        this.resyncing = false;
                    }
                });
        },
        bulkNotifyOrders() {
            if (!this.selectedRows.length) return;

            this.$swal
                .fire({
                    title: `Reenviar notificação de ${this.selectedRows.length} pedido(s)?`,
                    text: "Os vendedores serão novamente notificados sobre estes pedidos!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, reenviar",
                })
                .then(async (resp) => {
                    if (!resp.isConfirmed) return;

                    const orderIds = this.selectedRows.map((record) => record.id);

                    this.notifying = true;
                    try {
                        const { data: result } = await this.svc.notifyMany(orderIds);
                        const failed = result.failed?.length || 0;

                        if (failed) {
                            this.$swal.fire(
                                "Atenção",
                                `${result.notified.length} de ${orderIds.length} notificações reenviadas. ${failed} falharam.`,
                                "warning"
                            );
                        } else {
                            this.$swal.fire("Sucesso!", "Notificações reenviadas com sucesso!", "success");
                        }
                        this.clearSelection();
                    } catch (error) {
                        ErrorHandlerService.handle(error, this.$store);
                    } finally {
                        this.notifying = false;
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.ord-wrap {
    background-color: #f5f5f5;
}
.ord-title-card {
    width: 100%;
    margin-bottom: 10px;
}
.ord-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    h2 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
    }
}
.ord-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.ord-actions {
    display: flex;
    gap: 8px;
}
.ord-stats {
    margin-bottom: 10px;
    padding: 0 6px;
    overflow: hidden;
}
.ord-filterbar {
    margin-bottom: 0;

    ::v-deep(.ant-form-item) {
        margin-bottom: 0;
    }
}
.ord-filter-actions-col {
    display: flex;
    align-items: flex-end;
}
.ord-filter-actions {
    display: flex;
    gap: 8px;
    margin-left: auto;
    justify-content: flex-end;
}
::v-deep(.fixed-height-select.ant-select),
::v-deep(.fixed-height-select .ant-select-selection--multiple) {
    min-height: 32px !important;
    max-height: 32px !important;
    overflow: auto;
}
.ord-rating {
    display: flex;
    justify-content: center;
    margin: 16px 0;
}
.ord-rating-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: left;
}
.ord-card {
    --pri: var(--primary-color);
    width: 100%;
    overflow: hidden;

    ::v-deep(.ant-card-body) {
        width: 100%;
        padding: 0 !important;
        margin: 0 !important;
    }
    ::v-deep(.ant-table-wrapper),
    ::v-deep(.ant-table),
    ::v-deep(.ant-table-content),
    ::v-deep(table) {
        width: 100%;
        margin: 0 !important;
    }
}
</style>
